import PasswordResetForm from './PasswordResetForm'

export default PasswordResetForm



// WEBPACK FOOTER //
// ./src/components/PasswordResetForm/index.js